// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__zg8gc","wider":"button_wider__zTzB_","wider-center":"button_wider-center___5K4R","eventButton":"button_eventButton__KIEO3"};